import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Guid } from 'guid-typescript';
import { Course, UserDashboard, UserTopics, UserTopicStatus } from '../app.models';
import { AppService } from '../app.service';
import { SafeHtmlPipe } from '../templates/safe.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe, RouterLink],
})
export class CourseComponent implements OnInit {
  isCourseDataLoaded: boolean = false;
  course = new Course();
  userDashboard = new UserDashboard();
  userTopicStatus = new UserTopicStatus();
  firstName: string = '';
  lastName: string = '';
  emailAddress: string = '';
  mbtiType: string = '';
  courseName: string = '';
  allowCompare: boolean = true;
  courseId: Guid = Guid.createEmpty();
  hasStarted: boolean = false;
  incompleteTopicIds: string[] = [];
  //totCompletedTopics: number = 0;
  Http: HttpClient;
  HttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  public userTopicsStatus: UserTopicStatus[] = [];

  constructor(
    private appService: AppService,
    http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.Http = http;
  }

  ngOnInit() {
    this.mbtiType = this.appService.mbtiType;

    this.route.queryParams.subscribe((params) => {
      this.courseId = params['courseId'];

      if (!this.courseId) {
        this.router.navigate(['/learn']);
      }

      this.appService.getDashboard().subscribe(
        () => {
          this.GetDetailsByCourseId(this.courseId);
        },
        (error) => {
          this.appService.handleError(error);
        },
      );
    });
  }

  GetDetailsByCourseId(courseId: Guid) {
    this.appService.getCourse(this.courseId).subscribe(
      (result) => {
        if (result != null) {
          this.course = result;
          this.course.isCompleted = this.appService.getUserDashboard().userCourses.find((item) => item.courseId === courseId).isCompleted;
          this.allowCompare = this.appService.getUserDashboard().userCourses.find((item) => item.courseId === courseId).allowCompare;
          this.courseName = this.course.courseName.toUpperCase();

          //Get the user course topic status
          this.Http.get<UserTopics>('/api/user/usercoursetopics/' + courseId).subscribe(
            (data) => {
              if (data == null || (data != null && data.userTopicsStatus.length === 0)) {
                //Insert into user topics if no record exists or first time user for this course
                for (var topic of this.course.topics) {
                  const userTopicStatus = new UserTopicStatus();
                  userTopicStatus.topicId = topic.topicId;
                  userTopicStatus.lastPageVisited = 0;
                  this.userTopicsStatus.push(userTopicStatus);
                  this.incompleteTopicIds.push(topic.topicId);
                }

                const param = { CourseId: courseId, UserTopicsStatus: this.userTopicsStatus };
                this.Http.post('/api/user/usercoursetopics', param, this.HttpOptions).subscribe(
                  () => {
                    this.isCourseDataLoaded = true;
                  },
                  (error) => {
                    this.appService.handleError(error);
                  },
                );
              } else {
                try {
                  //Update course topic last visited page to reflect the current status.
                  for (var topic of this.course.topics) {
                    const topicLastPageCompleted = data.userTopicsStatus.find((item) => item.topicId === topic.topicId).lastPageVisited;
                    if (topicLastPageCompleted !== 0) {
                      this.hasStarted = true;
                    }
                    if (topicLastPageCompleted === topic.numPages && !topic.topicCompleted && topic.numPages > 0) {
                      topic.topicCompleted = true;
                      this.course.numCompletedTopics += 1;
                    } else {
                      this.incompleteTopicIds.push(topic.topicId);
                    }
                    topic.lastPageVisited = topicLastPageCompleted;
                  }

                  if (!this.course.isCompleted) {
                    this.course.isCompleted = this.course.topics.find((x) => x.topicCompleted === false) ? false : true;
                    if (this.course.isCompleted) {
                      //Update user course topics to completed
                      //get user record
                      this.userDashboard = this.appService.getUserDashboard();
                      for (let course of this.userDashboard.userCourses) {
                        if (course.courseId === courseId) course.isCompleted = true;
                      }

                      const updateParam = { SelectedModules: this.userDashboard.selectedModules, Courses: this.userDashboard.userCourses };
                      this.Http.put('/api/user/usercourses', updateParam, this.HttpOptions).subscribe(
                        () => {
                          this.appService.setUserDashboard(this.userDashboard);
                        },
                        (error) => {
                          this.appService.handleError(error);
                        },
                      );
                    }
                  }

                  this.isCourseDataLoaded = true;
                } catch (exception) {
                  this.appService.handleErrorWithRedirect(exception);
                }
              }
            },
            (error) => {
              this.appService.handleError(error);
              this.isCourseDataLoaded = true;
            },
          );
        } else {
          //if not data exist for the course or invalid course, retun to (dashboard) learn page
          this.router.navigate(['/learn']);
        }
      },
      (error) => {
        this.appService.handleError(error);
        this.isCourseDataLoaded = true;
      },
    );
  }
}
